const GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA =
  "GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA";
const SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA =
  "SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA";

const GET_ASSET_AUDIT_HISTORY_EXCEL_DATA = "GET_ASSET_AUDIT_HISTORY_EXCEL_DATA";
const SET_ASSET_AUDIT_HISTORY_EXCEL_DATA = "SET_ASSET_AUDIT_HISTORY_EXCEL_DATA";

const IS_GRID_LOADING = "IS_GRID_LOADING";

export {
  GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
  SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
  GET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  SET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  IS_GRID_LOADING
};
